import { createReducer, on } from "@ngrx/store";
import { BenefitGroup } from "../../models/benefit-group";
import { loadBenefitGroupByIdAct, resetBenefitGroupAct, saveSuccessBenefitGroupAct, setViolationsBenefitGroupAct, showMsgErrorAct, updateSuccessBenefitGroupAct } from "./benefit-group.action";

const benefitGroup: BenefitGroup = new BenefitGroup();

export const benefitGroupReducer = createReducer (
    {
        benefitGroup,
        violations: {},
        loading: true
    },
    on(resetBenefitGroupAct, (state) => ({
        benefitGroup:  { ...benefitGroup },
        violations: {},
        loading: state.loading
    })),
    on(loadBenefitGroupByIdAct, (state, { benefitGroup }) =>({
        benefitGroup: { ...benefitGroup}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessBenefitGroupAct, (state, { benefitGroupNew }) => ({
        benefitGroup: { ...benefitGroupNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessBenefitGroupAct, (state, { benefitGroupUpdated }) => ({
        benefitGroup: { ...benefitGroupUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsBenefitGroupAct, (state, { benefitGroupForm, violations }) => ({
        benefitGroup: { ...benefitGroupForm },
        violations: {...violations},
        loading: false
    })),
    on(showMsgErrorAct, (state, { error }) => ({
        benefitGroup: state.benefitGroup ,
        violations: {},
        loading: false
    }))
)